import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70f7a042&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f7a042')) {
      api.createRecord('70f7a042', component.options)
    } else {
      api.reload('70f7a042', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70f7a042&", function () {
      api.rerender('70f7a042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/withdrawals/index.vue"
export default component.exports